<template>
  <v-layout row wrap>
    <v-flex>

      <v-slide-y-transition mode="out-in">
        <v-container fluid class="pa-3">
          <v-layout row wrap>
            <v-flex>
              <v-card>
                <v-toolbar dense prominent>
                  <v-toolbar-title>Department Listing</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn small fab @click="addNewRecord_onClick()" v-on="on" color="primary">
                          <v-icon>
                            add_circle_outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Add new</span>
                    </v-tooltip>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text class="pa-0">
                  <v-container fluid>
                    <v-layout row wrap>
                      <v-expansion-panel>
                        <v-expansion-panel-content class="accent">
                          <template v-slot:header>
                            <div class="subheading">
                              Filter Panel
                            </div>
                          </template>

                          <v-btn color="green" @click="refreshData()"
                            >Generate Now</v-btn
                          >

                          <FilterEditor
                            :query.sync="new_filter"
                            :rules="get_filterable_columns"
                            class="accent"
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-data-table
                          id="company_table_id"
                          ref="company_table_ref"
                          :headers="table_setting.headers"
                          :items="table_setting.records"
                          :loading="table_setting.loading"
                          must-sort
                          :pagination.sync="table_setting.pagination"
                          :rows-per-page-items="table_setting.rows_per_page_items"
                          :total-items="table_setting.pagination.totalItems"
                          class="elevation-1"
                        >
                          <v-progress-linear
                            color="blue"
                            indeterminate
                          >
                            <template v-slot:progress>
                            </template>
                          </v-progress-linear>
                          <template v-slot:items="props">
                            <td class="pa-1 pl-3">{{ props.item.id }}</td>
                            <td class="pa-1">{{ props.item.company__name }}</td>
                            <td class="pa-1">{{ props.item.name }}</td>
                            <td class="pa-1">
                              {{ props.item.parent_dept__company__name }}
                            </td>
                            <td class="pa-1">{{ props.item.parent_dept__name }}</td>
                            <td class="pa-1">{{ convert_2_locale_datetime(props.item.created_date) }}</td>
                            <td class="pa-1">{{ props.item.desc }}</td>
                            <td class="pa-1">{{ props.item.g_status__value }}</td>
                            <td class="justify-center layout px-0">
                              <v-icon
                                small
                                class="mr-2"
                                color="orange"
                                @click="editRecord_onClick(props.item)"
                              >
                                edit
                              </v-icon>
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>

          <!-- START dialog -->
          <v-dialog
            v-model="dialog.visible"
            persistent
            scrollable
            max-width="600px"
          >
            <v-card>
              <v-card-title class="headline pb-0">
                {{ dialog.title }} Department Record
              </v-card-title>

              <v-card-text>
                <v-tabs
                  color="cyan"
                  slider-color="yellow"
                  v-model="tabs.active_tab_id"
                >
                  <v-tab ripple> Department </v-tab>
                  <v-tab ripple v-show="selected.id"> HOD</v-tab>
                  <v-tab ripple v-show="selected.id"> Employee</v-tab>

                  <v-tab-item class="tab-style">
                    <v-form>
                      <v-container grid-list-md class="pa-0">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-select
                              prepend-icon="domain"
                              :items="dialog.company_list"
                              v-model="selected.company_id"
                              v-validate="'required'"
                              :error-messages="errors.first('company')"
                              clearable
                              item-text="name"
                              item-value="id"
                              label="Company"
                              name="company"
                            ></v-select>
                          </v-flex>

                          <v-flex xs12>
                            <v-text-field
                              prepend-icon="local_offer"
                              name="name"
                              v-model="selected.name"
                              v-validate="'required|max:100'"
                              :error-messages="errors.first('name')"
                              label="Department Name"
                              type="text"
                              hint="Max 100 characters."
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-select
                              :items="dialog.parent_dept_list"
                              v-model="selected.parent_dept_id"
                              clearable
                              item-text="company_dept"
                              item-value="id"
                              label="Parent Department"
                              name="parent_department"
                            ></v-select>
                          </v-flex>

                          <v-flex xs12>
                            <v-textarea
                              v-model="selected.desc"
                              name="description"
                              label="Description"
                              hint="Max 1000 characters."
                            ></v-textarea>
                          </v-flex>

                          <v-flex xs12>
                            <v-select
                              :items="status_option"
                              v-model="selected.g_status_id"
                              item-text="value"
                              item-value="id"
                              label="Status"
                              name="status"
                            ></v-select>
                          </v-flex>

                          <v-flex xs12 class="text-xs-right">
                            <v-btn
                              color="green darken-1"
                              flat
                              @click="save_onClick()"
                            >
                              Save
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                  </v-tab-item>

                  <v-tab-item class="tab-style">
                    <v-layout row>
                      <v-flex xs12>
                        <v-list two-line subheader dense>
                          <v-list-tile
                            v-for="emp_item in hod_tab.saved_items"
                            :key="emp_item.id"
                            avatar
                          >
                            <v-list-tile-avatar>
                              <v-icon>how_to_reg</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                              <v-list-tile-title>{{
                                emp_item.emp__full_name
                              }}</v-list-tile-title>
                            </v-list-tile-content>

                            <!-- <v-list-tile-action>
                              <v-btn icon ripple @click="delete_hod(dept_emp_item)">
                                <v-icon color="grey lighten-1"
                                  >delete_forever</v-icon
                                >
                              </v-btn>
                            </v-list-tile-action> -->
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>

                  <v-tab-item class="tab-style">
                    <v-layout row>
                      <v-flex xs12>
                        <v-list two-line subheader dense>
                          <v-list-tile
                            v-for="emp_item in employee_tab.saved_items"
                            :key="emp_item.id"
                            avatar
                          >
                            <v-list-tile-avatar>
                              <v-icon>person</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                              <v-list-tile-title>{{
                                emp_item.emp__full_name
                              }}</v-list-tile-title>
                            </v-list-tile-content>

                            <!-- <v-list-tile-action>
                              <v-btn icon ripple @click="delete_hod(dept_emp_item)">
                                <v-icon color="grey lighten-1"
                                  >delete_forever</v-icon
                                >
                              </v-btn>
                            </v-list-tile-action> -->
                          </v-list-tile>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                </v-tabs>
              </v-card-text>

              <v-card-actions>
                <v-container>
                  <v-layout row wrap>
                    <v-flex class="text-xs-right">
                      <v-btn
                        color="orange"
                        flat
                        @click="
                          dialog.visible = false;
                          tabs.active_tab_id = 0;
                        "
                      >
                        Close
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- END dialog -->
        </v-container>
      </v-slide-y-transition>

    </v-flex>
  </v-layout>
</template>

<script>
import common from "../../functions/general";
import qb from "../../functions/query.builder";
import FilterEditor from "../../components/FilterEditor";

export default {
  name: "DepartmentListingPage",
  components: {
    FilterEditor: FilterEditor
  },
  data() {
    return {
      new_filter: {
        condition: "and",
        rules: []
      },
      status_option: [],
      dialog: {
        visible: false,
        title: "",
        parent_dept_list: [],
        company_list: []
      },
      tabs: {
        active_tab_id: 0
      },
      hod_tab: {
        saved_items: []
      },
      employee_tab: {
        saved_items: []
      },
      selected: {
        id: "",
        name: "",
        desc: "",
        company_id: "",
        company__name: "",
        parent_dept_id: "",
        g_status_id: ""
      },
      table_setting: {
        loading: false,
        rows_per_page_items: [10],
        headers: [
          {
            text: "ID#",
            value: "id",
            class: "pa-1 pl-3",
            filterable: true,
            data_type: Number
          },
          {
            text: "Company",
            class: "pa-1",
            value: "company__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Dept Name",
            class: "pa-1",
            value: "name",
            filterable: true,
            data_type: String
          },
          {
            text: "Parent Company",
            class: "pa-1",
            value: "parent_dept__company__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Parent Dept Name",
            class: "pa-1",
            value: "parent_dept__name",
            filterable: true,
            data_type: String
          },
          {
            text: "Created DateTime",
            align: "left",
            class: "pa-1",
            value: "created_date",
            filterable: true,
            data_type: Number
          },
          {
            text: "Description",
            align: "left",
            class: "pa-1",
            value: "desc",
            filterable: true,
            data_type: String
          },
          {
            text: "Status",
            align: "left",
            class: "pa-1",
            value: "g_status__value",
            filterable: true,
            data_type: String
          },
          {
            text: "",
            value: "a_actions",
            class: "pa-1",
            filterable: false,
            data_type: Number
          }
        ],
        records: [],
        pagination: {
          descending: false,
          page: 1,
          rowsPerPage: 10,
          sortBy: "company__name",
          totalItems: 0
        }
      }
      //   listing: {
      //     items: [],
      //     pagination: {
      //       descending: false,
      //       page: 1,
      //       rowsPerPage: 16,
      //       sortBy: "",
      //       totalItems: 0
      //     },
      //     rowsPerPageItems: [8, 16, 24]
      //   }
    };
  },
  computed: {
    get_filterable_columns() {
      var return_value = this.table_setting.headers.filter(
        rec => rec.filterable == true
      );
      return return_value;
    }
  },
  watch: {
    "selected.id"(val) {
      if (val != "") {
        this.refresh_dept_employee(val);
        this.refresh_hod(val);
      }
    },
    "table_setting.pagination": {
      handler: function() {
        this.refreshData();
      },
      deep: true
    }
  },
  async mounted() {
    this.status_option = await common.App.getGeneralOptions(
      "General",
      "status",
      ["id", "value"]
    );

    let cls_qb = new qb.QueryBuilder();

    cls_qb.Method = "all";

    cls_qb.Select = ["id", "name"];

    cls_qb.Order = ["name"];
    let result = await common.wBackEndComm.PostData(
      "company/company_listing/",
      cls_qb
    );

    if (result.data.Status == 1) {
      //this.listing.items = result.data.Body.records;
      this.dialog.company_list = result.data.Body.records;
    } else {
      common.wMsgBox.Error(result.data.Description);
    }



    cls_qb = new qb.QueryBuilder();
    cls_qb.Method = "all";
    cls_qb.Select = [
      "id",
      "name",
      "desc",
      "g_status_id",
      "g_status__value",
      "company_id",
      "company__name",
      "parent_dept_id",
      "created_date",
      "parent_dept__company__name",
      "parent_dept__name"
    ];
    // cls_qb.Where = this.new_filter
    
    cls_qb.Order = ["company__name", "name"];

    result = await common.wBackEndComm.PostData(
      "department/department_listing/",
      cls_qb
    );
    if (result.data.Status == 1) {
      for (let i = 0, m = result.data.Body.records.length; i < m; i++) {
        const element = result.data.Body.records[i]  
        element["company_dept"] =
          element["company__name"] + " - " + element["name"];
      }
      this.dialog.parent_dept_list = result.data.Body.records;
    } else {
      common.wMsgBox.Error(result.data.Description);
    }
  


  },
  methods: {
    convert_2_locale_datetime(date) {
      return common.App.to_locale_datetime(date);
    },
    async refresh_hod(dept_id) {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";

      cls_qb.Select = ["id", "emp__full_name"];

      var rule = new qb.Rule();

      rule
        .field("dept_id")
        .operator(qb.NUM_OPERATOR.EQUAL)
        .value(dept_id);

      cls_qb.addRule(rule);

      // OWK: only active staffs
      rule = new qb.Rule();
      rule
        .field("emp_id__emp_status_id")
        .operator(qb.NUM_OPERATOR.EQUAL)
        .value(1);
      cls_qb.addRule(rule);
      
      //cls_qb.Order = ["-created_date"];
      let result = await common.wBackEndComm.PostData("hod/listing/", cls_qb);

      if (result.data.Status == 1) {
        this.hod_tab.saved_items = result.data.Body.records;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    async refresh_dept_employee(dept_id) {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";

      cls_qb.Select = ["id", "emp__full_name"];

      var rule = new qb.Rule();

      rule
        .field("dept_id")
        .operator(qb.NUM_OPERATOR.EQUAL)
        .value(dept_id);

      cls_qb.addRule(rule);

      // OWK: only active staffs
      rule = new qb.Rule();
      rule
        .field("emp_id__emp_status_id")
        .operator(qb.NUM_OPERATOR.EQUAL)
        .value(1);
      cls_qb.addRule(rule);

      //cls_qb.Order = ["-created_date"];
      let result = await common.wBackEndComm.PostData(
        "dept_employee/listing/",
        cls_qb
      );

      if (result.data.Status == 1) {
        this.employee_tab.saved_items = result.data.Body.records;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    async refreshData() {
      let cls_qb = new qb.QueryBuilder();

      cls_qb.Method = "all";

      cls_qb.Select = [
        "id",
        "name",
        "desc",
        "g_status_id",
        "g_status__value",
        "company_id",
        "company__name",
        "parent_dept_id",
        "created_date",
        "parent_dept__company__name",
        "parent_dept__name"
      ];

      cls_qb.Where = this.new_filter;

      if (this.table_setting.pagination.rowsPerPage > 0) {
        cls_qb.Offset =
          (this.table_setting.pagination.page - 1) *
          this.table_setting.pagination.rowsPerPage;
        cls_qb.Limit = this.table_setting.pagination.rowsPerPage;
      }

      cls_qb.Order = [
        this.table_setting.pagination.descending
          ? "-" + this.table_setting.pagination.sortBy
          : this.table_setting.pagination.sortBy
      ];

      let result = await common.wBackEndComm.PostData(
        "department/department_listing/",
        cls_qb
      );

      if (result.data.Status == 1) {
        this.table_setting.records = result.data.Body.records;
        this.table_setting.pagination.totalItems =
        result.data.Body.total_records_after_filtered;
      } else {
        common.wMsgBox.Error(result.data.Description);
      }
    },
    editRecord_onClick(item) {
      this.dialog.visible = true;
      this.dialog.title = "Modifying ";

      this.$validator.reset();

      this.selected = {
        id: item["id"],
        name: item["name"],
        desc: item["desc"],
        company_id: item["company_id"],
        company__name: item["company__name"],
        parent_dept_id: item["parent_dept_id"],
        g_status_id: item["g_status_id"]
      };
    },
    addNewRecord_onClick() {
      this.dialog.visible = true;
      this.dialog.title = "Create";

      this.$validator.reset();

      this.selected = {
        id: "",
        name: "",
        desc: "",
        company_id: "",
        company__name: "",
        parent_dept_id: "",
        g_status_id: this.status_option[0].id
      };
    },
    save_onClick() {
      let self = this;

      this.$validator.validateAll().then(async result => {
        if (result) {
          let result = await common.wBackEndComm.PostData(
            "department/crud_department/",
            self.selected
          );

          if (result.data.Status == 1) {
            self.dialog.visible = false;
            self.refreshData();
            common.wMsgBox.Success(result.data.Description);
          } else {
            common.wMsgBox.Error(result.data.Description);
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.tab-style {
  height: 500px;
  margin-top: 5px;
}
</style>
